// JsFromRoutes CacheKey e7ddb2ed5aa8c6997168751f2006c82a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const medical = {
  create: definePathHelper("post", "/medical"),
  update: definePathHelper("patch", "/medical/:id"),
};
